// @flow
import * as React from 'react';
import { Template } from '../Template';
import { ExchangeForm } from '../../atoms/Forms';

export const ExchangeEditTemplate = (props) => (
  <Template menuItem="funds" {...props}>
    <h1>Edit Exchange</h1>
    <ExchangeForm {...props} />
  </Template>
  );